/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Roadmap_WikiInputs */

const en_roadmap_wiki = /** @type {(inputs: Roadmap_WikiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiki`)
};

const id_roadmap_wiki = /** @type {(inputs: Roadmap_WikiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiki`)
};

/**
* | output |
* | --- |
* | "Wiki" |
*
* @param {Roadmap_WikiInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const roadmap_wiki = /** @type {((inputs?: Roadmap_WikiInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Roadmap_WikiInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_roadmap_wiki(inputs)
	return en_roadmap_wiki(inputs)
});